export default "__VITE_ASSET__2f0f97b0__"